document.addEventListener("DOMContentLoaded", function () {
    var splide = new Splide("#round_tab", {
      type: "slide",
      perPage: 5,
      pagination: false,
      gap: 40,
      breakpoints: {
        768: {
          perPage: 3,
          gap: 20,
        },
        480: { 
          perPage: 3,
          gap: 0,
        },
      },
    });
  
    splide.mount();
  
    const isGrid =
      document
        .querySelector(".Shop-by-concern--collection-splide")
        .getAttribute("data-is-grid") === "true";
    var splideInstances = [];
  
    if (!isGrid) {
      var sliders = document.querySelectorAll(".Shop-by-concern--collection");
  
      sliders.forEach(function (slider) {
        var splideInstance = new Splide(slider.querySelector(".splide"), {
          type: "slide",
          perPage: 4,
          perMove: 1,
          gap: 20,
          pagination: true,
          breakpoints: {
            980: {
              perPage: 3,
              gap: 16,
              perMove: 1,
            },
            480: {
              perPage: 2,
              gap: 8,
              perMove: 1,
            },
          },
        }).mount();
  
        splideInstances.push(splideInstance);
      });
  
      const handleViewportChange = () => {
        isDesktop = window.matchMedia("(min-width: 768px)").matches;
      };
  
      window.addEventListener("resize", handleViewportChange);
  
      function adjustMargins() {
        var slides = document.querySelectorAll(".splide__slide");
        if (window.innerWidth <= 1024 && window.innerWidth > 768) {
          slides.forEach((slide) => {
            slide.style.marginRight = "auto";
          });
        } else if (window.innerWidth <= 768 && window.innerWidth > 480) {
          slides.forEach((slide) => {
            slide.style.marginRight = "auto";
          });
        } else if (window.innerWidth <= 480) {
          slides.forEach((slide) => {
            slide.style.marginRight = "10px";
          });
        } else {
          slides.forEach((slide) => {
            slide.style.marginRight = "40px";
          });
        }
      }
  
      adjustMargins();
  
      window.addEventListener("resize", function () {
        adjustMargins();
      });
    }
  
    const listItems = document.querySelectorAll(
      ".shop-by-concern--splide--slide"
    );
    const tabSliders = document.querySelectorAll(".Shop-by-concern--collection");
    let isDesktop = window.matchMedia("(min-width: 768px)").matches;
  
    const firstItem = listItems[0];
    firstItem.classList.add("now-active");
    firstItem
      .querySelector(".shop-by-concern--slide-wrapper")
      .classList.add("active");
    firstItem.querySelector(".shop-by-concern--svg-wrapper").style.display =
      "flex";
    tabSliders[0].classList.remove("hidden");
  
    listItems.forEach((item) => {
      item.addEventListener("click", function () {
        if (!this.classList.contains("now-active")) {
          listItems.forEach((li) => {
            li.querySelector(".shop-by-concern--slide-wrapper").classList.remove(
              "active"
            );
            li.querySelector(".shop-by-concern--svg-wrapper").style.display =
              "none";
            li.classList.remove("now-active");
          });
  
          this.querySelector(".shop-by-concern--slide-wrapper").classList.add(
            "active"
          );
          this.querySelector(".shop-by-concern--svg-wrapper").style.display =
            "flex";
          this.classList.add("now-active");
  
          const activeIndex = this.getAttribute("data-index");
  
          tabSliders.forEach((slider) => {
            const sliderIndex = slider.getAttribute("data-index");
            if (sliderIndex === activeIndex) {
              slider.classList.remove("hidden");
            } else {
              slider.classList.add("hidden");
            }
          });
        }
      });
  
      item.addEventListener("focus", function () {
        if (isDesktop) {
          this.classList.remove("is-active");
        }
      });
    });
  
    const handleViewportChange = () => {
      isDesktop = window.matchMedia("(min-width: 768px)").matches;
    };
  
    window.addEventListener("resize", handleViewportChange);
  });
  